import { render, staticRenderFns } from "./TalksPage.vue?vue&type=template&id=0dec87cb&scoped=true"
import script from "./TalksPage.vue?vue&type=script&lang=js"
export * from "./TalksPage.vue?vue&type=script&lang=js"
import style0 from "./TalksPage.vue?vue&type=style&index=0&id=0dec87cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dec87cb",
  null
  
)

export default component.exports